(function () {
  'use strict';

  var SIDEBAR_SELECTOR = '[data-tp-quick-cart]';
  var TP_PRODUCT_FORM_SELECTOR = '.tp-pdp__form';
  var applying = false;
  var scheduled = false;
  var drawerRequest = null;
  var lastDrawerOpener = null;

  function shopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function textData(sidebar, key) {
    return (sidebar.dataset[key] || '').trim();
  }

  function setTextIfChanged(element, value) {
    if (!element || !value) return;
    if (element.textContent.trim() !== value) element.textContent = value;
  }

  function currentProductIds(root) {
    var ids = Array.from(root.querySelectorAll('[data-tp-cart-product]'))
      .map(function (element) { return String(element.dataset.tpCartProduct || ''); })
      .filter(Boolean);

    if (!ids.length) {
      ids = Array.from(root.querySelectorAll('cart-update-quantity[data-product]'))
        .map(function (element) { return String(element.dataset.product || ''); })
        .filter(Boolean);
    }

    return Array.from(new Set(ids)).sort();
  }

  function syncActionLabels(sidebar, root) {
    setTextIfChanged(root.querySelector('.button-checkout'), textData(sidebar, 'tpCheckoutLabel'));
    setTextIfChanged(root.querySelector('.button-view-cart'), textData(sidebar, 'tpViewCartLabel'));
  }

  function syncTrust(sidebar, root) {
    var action = root.querySelector('.previewCartAction');
    if (!action) return;

    var one = textData(sidebar, 'tpTrustOne');
    var two = textData(sidebar, 'tpTrustTwo');
    var helperText = textData(sidebar, 'tpHelper');
    if (!one && !two && !helperText) return;

    var info = action.closest('.previewCartInfo');
    if (!info) return;

    var trust = info.querySelector('[data-tp-cart-trust]');
    if (!trust && (one || two)) {
      trust = document.createElement('div');
      trust.className = 'tp-cart-trust';
      trust.dataset.tpCartTrust = '';
      trust.setAttribute('aria-label', 'Shopping reassurance');
      trust.innerHTML =
        '<div class="tp-cart-trust__item"><span class="tp-cart-trust__mark" aria-hidden="true">✓</span><span data-tp-trust-one></span></div>' +
        '<div class="tp-cart-trust__item"><span class="tp-cart-trust__mark" aria-hidden="true">✓</span><span data-tp-trust-two></span></div>';
      info.insertBefore(trust, action);
    }

    if (trust) {
      setTextIfChanged(trust.querySelector('[data-tp-trust-one]'), one);
      setTextIfChanged(trust.querySelector('[data-tp-trust-two]'), two);
    }

    var group = action.querySelector('.previewCartGroup');
    if (!group || !helperText) return;

    var helper = action.querySelector('[data-tp-cart-helper]');
    if (!helper) {
      helper = document.createElement('p');
      helper.className = 'tp-cart-helper';
      helper.dataset.tpCartHelper = '';
      group.insertAdjacentElement('afterend', helper);
    }
    setTextIfChanged(helper, helperText);
  }

  function syncEmptyState(sidebar, root) {
    var emptyBody = root.querySelector('.previewCart-emptyBody');
    if (!emptyBody) return;

    var title = emptyBody.querySelector('.empty .text');
    setTextIfChanged(title, textData(sidebar, 'tpEmptyTitle'));

    var copy = emptyBody.querySelector('[data-tp-cart-empty-copy]');
    if (!copy) {
      copy = document.createElement('p');
      copy.className = 'tp-cart-empty-copy';
      copy.dataset.tpCartEmptyCopy = '';
      var empty = emptyBody.querySelector('.empty');
      if (empty) empty.insertAdjacentElement('afterend', copy);
    }
    setTextIfChanged(copy, textData(sidebar, 'tpEmptyCopy'));

    var button = emptyBody.querySelector('.button-continue');
    if (button) {
      setTextIfChanged(button, textData(sidebar, 'tpEmptyCta'));
      var url = textData(sidebar, 'tpEmptyUrl');
      if (url && button.getAttribute('href') !== url) button.setAttribute('href', url);
      button.removeAttribute('role');
      button.removeAttribute('aria-disabled');
      button.removeAttribute('onclick');
    }
  }

  function syncUpsell(sidebar, root) {
    var preview = root.querySelector('.previewCart');
    var list = root.querySelector('.previewCartList');
    if (!preview || !list || !list.querySelector('[data-item-row]')) {
      var noCartUpsell = root.querySelector('[data-tp-cart-upsell]');
      if (noCartUpsell) noCartUpsell.remove();
      return;
    }

    var template = sidebar.querySelector('[data-tp-cart-upsell-template]');
    if (!template || !template.content) return;

    var ids = currentProductIds(root);
    var cartKey = ids.join('|');
    var existing = root.querySelector('[data-tp-cart-upsell]');

    if (existing && existing.dataset.tpCartKey === cartKey) return;
    if (existing) existing.remove();

    var fragment = template.content.cloneNode(true);
    var section = fragment.querySelector('[data-tp-cart-upsell]');
    if (!section) return;

    var shown = 0;
    Array.from(section.querySelectorAll('[data-tp-upsell-card]')).forEach(function (card) {
      var productId = String(card.dataset.tpUpsellProduct || '');
      if (!productId || ids.indexOf(productId) !== -1 || shown >= 4) {
        card.remove();
        return;
      }
      shown += 1;
    });

    if (!shown) return;

    section.dataset.tpCartKey = cartKey;
    preview.appendChild(section);
  }

  function hideLegacyUpsell(root) {
    root.querySelectorAll('.previewCartCollection').forEach(function (element) {
      if (!element.hasAttribute('data-tp-cart-upsell')) element.hidden = true;
    });
  }

  function apply(sidebar) {
    if (!sidebar || applying) return;
    applying = true;

    try {
      var root = sidebar.querySelector('.previewCart-wrapper');
      if (!root) return;

      syncActionLabels(sidebar, root);
      syncTrust(sidebar, root);
      syncEmptyState(sidebar, root);
      hideLegacyUpsell(root);
      syncUpsell(sidebar, root);
    } finally {
      applying = false;
    }
  }

  function schedule(sidebar) {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply(sidebar);
    });
  }

  function runInsertedScripts(root) {
    root.querySelectorAll('script').forEach(function (oldScript) {
      if (oldScript.src) return;
      var script = document.createElement('script');
      if (oldScript.type) script.type = oldScript.type;
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      element.textContent = cart.item_count;
      element.setAttribute('data-cart-count-value', String(cart.item_count));
    });
  }

  function openDrawer(sidebar) {
    if (!sidebar) return;

    lastDrawerOpener = document.activeElement && document.activeElement !== document.body
      ? document.activeElement
      : lastDrawerOpener;

    document.body.classList.remove('add-to-cart-show');
    document.body.classList.add('cart-sidebar-show');
    sidebar.setAttribute('aria-hidden', 'false');
    sidebar.setAttribute('role', 'dialog');
    sidebar.setAttribute('aria-modal', 'true');

    window.setTimeout(function () {
      var close = sidebar.querySelector('[data-close-cart-sidebar]');
      if (close && typeof close.focus === 'function') {
        try { close.focus({ preventScroll: true }); } catch (error) { close.focus(); }
      }
    }, 80);
  }

  function closeDrawer() {
    var sidebar = document.querySelector(SIDEBAR_SELECTOR);
    document.body.classList.remove('cart-sidebar-show');
    if (sidebar) sidebar.setAttribute('aria-hidden', 'true');

    if (lastDrawerOpener && document.contains(lastDrawerOpener) && typeof lastDrawerOpener.focus === 'function') {
      window.setTimeout(function () {
        try { lastDrawerOpener.focus({ preventScroll: true }); } catch (error) { lastDrawerOpener.focus(); }
        lastDrawerOpener = null;
      }, 80);
    }
  }

  async function refreshAndOpenDrawer() {
    if (drawerRequest) return drawerRequest;

    drawerRequest = (async function () {
      var sidebar = document.querySelector(SIDEBAR_SELECTOR);
      if (!sidebar) throw new Error('Toni Pons cart drawer is not available on this page.');

      var root = sidebar.querySelector('.previewCart-wrapper');
      if (!root) throw new Error('Toni Pons cart content container is missing.');

      root.setAttribute('aria-busy', 'true');
      var base = shopRoot();

      try {
        var responses = await Promise.all([
          fetch(base + 'cart?view=ajax_side_cart', {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }),
          fetch(base + 'cart.js', {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
        ]);

        if (!responses[0].ok) throw new Error('Unable to refresh the cart drawer.');
        if (!responses[1].ok) throw new Error('Unable to refresh the cart count.');

        var html = await responses[0].text();
        var cart = await responses[1].json();

        root.innerHTML = html;
        runInsertedScripts(root);
        updateCartCount(cart);
        apply(sidebar);
        openDrawer(sidebar);

        document.dispatchEvent(new CustomEvent('tp:cart:opened', {
          detail: { cart: cart }
        }));

        return cart;
      } finally {
        root.removeAttribute('aria-busy');
      }
    })();

    try {
      return await drawerRequest;
    } finally {
      drawerRequest = null;
    }
  }

  function errorMessageForForm(form, message) {
    var section = form.closest('[id^="tp-product-"]') || form.parentElement;
    var messageBox = section ? section.querySelector('[data-variant-message]') : null;
    if (!messageBox) return;

    messageBox.textContent = message || 'تعذر إضافة المنتج إلى الحقيبة. يرجى المحاولة مرة أخرى.';
    messageBox.removeAttribute('hidden');
    messageBox.setAttribute('role', 'alert');
  }

  function clearFormError(form) {
    var section = form.closest('[id^="tp-product-"]') || form.parentElement;
    var messageBox = section ? section.querySelector('[data-variant-message]') : null;
    if (!messageBox) return;
    messageBox.textContent = '';
    messageBox.removeAttribute('role');
  }

  async function addTpProduct(form) {
    if (!form || form.dataset.tpCartSubmitting === 'true') return;

    var addButton = form.querySelector('[data-add], button[name="add"]');
    if (!addButton || addButton.disabled) return;

    var addLabel = addButton.querySelector('[data-add-label]');
    var originalLabel = addLabel ? addLabel.textContent : '';
    var variantInput = form.querySelector('input[name="id"]');

    if (!variantInput || !variantInput.value) {
      errorMessageForForm(form, 'اختاري المقاس قبل الإضافة إلى الحقيبة.');
      return;
    }

    form.dataset.tpCartSubmitting = 'true';
    addButton.disabled = true;
    addButton.setAttribute('aria-busy', 'true');
    if (addLabel) addLabel.textContent = 'جارٍ الإضافة...';
    clearFormError(form);

    try {
      var response = await fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(form)
      });

      var payload = null;
      try { payload = await response.json(); } catch (error) { payload = null; }

      if (!response.ok) {
        var description = payload && (payload.description || payload.message)
          ? (payload.description || payload.message)
          : 'تعذر إضافة هذا المنتج إلى الحقيبة. يرجى المحاولة مرة أخرى.';
        throw new Error(description);
      }

      if (addLabel) addLabel.textContent = 'تمت الإضافة';

      try {
        await refreshAndOpenDrawer();
      } catch (drawerError) {
        var sidebar = document.querySelector(SIDEBAR_SELECTOR);
        if (sidebar) openDrawer(sidebar);
        throw drawerError;
      }
    } catch (error) {
      errorMessageForForm(form, error && error.message ? error.message : 'تعذر إضافة المنتج إلى الحقيبة. يرجى المحاولة مرة أخرى.');
      console.error('[Toni Pons Quick Cart]', error);
    } finally {
      window.setTimeout(function () {
        form.dataset.tpCartSubmitting = 'false';
        addButton.removeAttribute('aria-busy');
        addButton.disabled = false;
        if (addLabel && originalLabel) addLabel.textContent = originalLabel;
      }, 450);
    }
  }

  function initSidebar(sidebar) {
    if (!sidebar || sidebar.dataset.tpQuickCartReady === 'true') return;
    sidebar.dataset.tpQuickCartReady = 'true';
    sidebar.setAttribute('aria-hidden', document.body.classList.contains('cart-sidebar-show') ? 'false' : 'true');

    schedule(sidebar);

    var observer = new MutationObserver(function () {
      schedule(sidebar);
    });

    observer.observe(sidebar, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    document.querySelectorAll(SIDEBAR_SELECTOR).forEach(initSidebar);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest(TP_PRODUCT_FORM_SELECTOR) : null;
    if (!form) return;

    if (event.submitter && !event.submitter.matches('[data-add], button[name="add"]')) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    addTpProduct(form);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-close-cart-sidebar]')) {
      closeDrawer();
      return;
    }

    var overlay = event.target.closest('.background-overlay');
    if (overlay && document.body.classList.contains('cart-sidebar-show')) {
      closeDrawer();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.body.classList.contains('cart-sidebar-show')) {
      closeDrawer();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.TPQuickCart = {
    open: refreshAndOpenDrawer,
    close: closeDrawer,
    refresh: refreshAndOpenDrawer
  };
})();
